import { render, staticRenderFns } from "./AboutSwiper7.vue?vue&type=template&id=2724b748&scoped=true&"
import script from "./AboutSwiper7.vue?vue&type=script&lang=js&"
export * from "./AboutSwiper7.vue?vue&type=script&lang=js&"
import style0 from "./AboutSwiper7.vue?vue&type=style&index=0&id=2724b748&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2724b748",
  null
  
)

export default component.exports